import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  Addressee,
  CommunicationService,
  InternalEmail
} from '@amfam/shared/utility/shared-services';

import { ContactAdjusterInternalEmail } from './contact-adjuster-internalemail.model';

@Injectable()
export class ContactAdjusterService {
  constructor(private communicationService: CommunicationService) {}

  public generateInternalEmail(model: ContactAdjusterInternalEmail): Observable<any> {
    const email: InternalEmail = new InternalEmail();
    const emailAddress: string = model.adjusterEmail;
    email.messageFrom = new Addressee('contact_adjuster@amfam.com', 'Contact Adjuster');
    email.messageToList.push(new Addressee(emailAddress, model.adjusterName));
    email.messageSubject = `${model.claimNumber}: American Family Insurance Claim Communication`;
    email.messageContent = this.generateInternalEmailContent(model);

    return this.communicationService.sendInternalEmail(email);
  }

  private generateInternalEmailContent(model: ContactAdjusterInternalEmail): string {
    let content = `Dear ${model.adjusterName},<br><br>`;
    content += `The customer below has submitted a question/comment about his/her claim(s) from My Account.<br><br>`;
    content += `Please contact the customer within two business days to discuss their request.<br><br>`;
    content += `Thank you,<br>The amfam.com Team`;
    content += `<br><br><hr/><br><br>Request Change<br>`;
    content += `The following is the message from the customer about his/her claim(s).<br><br>`;
    content += `<table><tr><td>Last Name</td><td>${model.lastName}</td></tr>`;
    content += `<tr><td>First Name</td><td>${model.firstName}</td></tr>`;
    content += `<tr><td>Email</td><td>${model.email}</td></tr>`;
    content += `<tr><td>Phone</td><td>${model.phone}</td></tr>`;
    content += `<tr><td>Comments</td><td>${model.comment}</td></tr>`;
    content += `</table>`;
    content += `<br><br><hr/>`;

    return content;
  }
}
